<template>
  <div class="message-box fixed bottom">
    <div class="message-template" v-if="topicReplyTemplatesShow">
      <div class="template-header d-flex align-items-center">
        <div class="flex-fill flex-grow-1">
          <h5 class="">ข้อความตอบกลับตั้งต้น</h5>
        </div>
        <div class="flex-fill text-right">
          <button
            type="button"
            class="close-button"
            @click="closeMessageTemplate()"
          >
            <img src="/static/icons/close.svg" class="message-icon" />
          </button>
        </div>
      </div>
      <div class="template-body d-flex">
        <ul class="list" v-if="topicReplyTemplates">
          <li
            v-for="(template, index) in topicReplyTemplates"
            :key="index"
            class="pointer"
            @click="appendMessage(template)"
          >
            {{ template }}
          </li>
          <li v-if="topicReplyTemplates.length === 0">
            ไม่พบข้อมูล
          </li>
        </ul>
      </div>
    </div>
    <div class="message-title" v-if="title">
      <div class="message-title-header d-flex align-items-center">
        <div class="flex-fill flex-grow-1">
          <h5 class="">{{ title }}</h5>
        </div>
        <div class="flex-fill text-right">
          <button
            type="button"
            class="close-button"
            @click="$emit('message-close')"
          >
            <img src="/static/icons/close.svg" class="message-icon" />
          </button>
        </div>
      </div>
    </div>
    <div class="image-box" v-if="isSelectImage">
      <div v-for="(selectImage, index) in selectImages" :key="index">
        <div class="topic-image">
          <sc-thumbnail
            :imgSrc="selectImage.url"
            :imgClass="'topic-image p-0 m-0'"
            :openLink="false"
          ></sc-thumbnail>
          <img
            src="/static/icons/cancel-black.svg"
            class="position-absolute image-remove pointer"
            @click="onRemoveImage(selectImage.key)"
          />
        </div>
      </div>
    </div>
    <div class="pdf-box" v-if="selectPDF.url">
      <div class="topic-pdf">
        <div class="pdf-text">{{ selectPDF.name }}</div>
        <img
          src="/static/icons/cancel-black.svg"
          class="position-absolute image-remove pointer"
          @click="onRemovePDF()"
        />
      </div>
    </div>
    <div class="message-input">
      <div class="input-actions d-flex align-items-center">
        <img
          src="/static/icons/topic-add-picture.svg"
          class="message-icon"
          @click="onSelectImage()"
        />
        <input
          type="file"
          accept="image/jpg, image/png, image/jpeg"
          ref="imageInput"
          hidden
          multiple
          @change="imageChange($event.target.files)"
        />
        <img
          src="/static/icons/add-pdf-file.svg"
          height="31px"
          width="31px"
          class="message-icon"
          @click="onSelectPDF()"
        />
        <input
          type="file"
          accept="application/pdf"
          ref="pdfInput"
          hidden
          @change="pdfFileChange($event.target.files)"
        />
        <img
          src="/static/icons/topic-preset-message.svg"
          class="message-icon"
          @click="getReplyTemplates"
        />
        <img
          src="/static/icons/topic-send.svg"
          class="message-icon ml-auto"
          @click="sendMessage"
        />
      </div>
      <div class="media">
        <div class="media-body">
          <textarea
            name=""
            id=""
            class="message-textarea"
            v-model="message"
            :placeholder=placeHolder
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { UPLOAD } from "@/config/constant";
import Thumbnail from "@/components/helper/Thumbnail";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  props: {
    contactId: {
      required: true
    },
    homeId: {},
    projectId: {},
    title: {
      type: String
    },
    type: {
      type: String,
      default: "conversation"
    },
    placeHolder: {
      type: String,
      default: "พิมพ์ตอบที่นี่"
    },
  },
  components: {
    "sc-thumbnail": Thumbnail
  },
  computed: {
    isSelectImage() {
      return this.selectImages.length > 0
    }
  },
  data() {
    return {
      message: "",
      selectImages: [],
      selectPDF: {},
      topicReplyTemplates: null,
      topicReplyTemplatesShow: false,
      defaultAdminIcon: "/static/icons/sc-profile-default.png"
    };
  },
  methods: {
    getUrlRequestForTemplate() {
      switch (this.type) {
        case "conversation":
          return `${process.env.HOST}/admin/conversations/templates`;
        case "greeting":
          return `${process.env.HOST}/admin/greeting/templates`;
        default:
          return `${process.env.HOST}/admin/conversations/templates`;
      }
    },
    getReplyTemplates() {
      const vm = this;
      if (vm.topicReplyTemplates === null) {
        axios
          .get(this.getUrlRequestForTemplate(), {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
            }
          })
          .then(res => {
            vm.topicReplyTemplates = res.data;
            this.topicReplyTemplatesShow = true;
          });
      } else {
        this.topicReplyTemplatesShow = true;
      }
    },
    async sendMessage() {
      if (this.type === "greeting") {
        await this.sendGreetingMessage();
      } else {
        await this.sendConversationMessage();
      }
    },
    async sendConversationMessage() {
      if (
        this.message.trim().length === 0
        && this.selectImages.length === 0
      ) return false;

      const now = Date.now();

      const imageKeys = this.selectImages.length > 0
          ? this.selectImages.map((selectImage) => selectImage.key)
          : null

      const images = this.selectImages.length > 0
          ? this.selectImages.map((selectImage) => selectImage.url)
          : null

      const newReply = {
        imageKeys,
        images,
        pdfName: this.selectPDF.name,
        pdfKey: this.selectPDF.key,
        status: null,
        message: this.message.trim().length > 0
          ? this.message.trim()
          : null,
        sentimentScore: null,
        userId: null,
        adminId: 1,
        createdAt: now,
        updated_at: now,
        createdByUser: null,
        profileImage: this.defaultAdminIcon,
        createdByAdmin: {
          firstName: localStorage.getItem("adminFirstName"),
          lastName: localStorage.getItem("adminLastName")
        },
        sent: false
      };

      const data = {};
      if (newReply.imageKeys) data.imageKeys = newReply.imageKeys;
      if (newReply.pdfKey) {
        data.pdfName = newReply.pdfName;
        data.pdfKey = newReply.pdfKey;
      }

      data.message = newReply.message;
      data.homeId = this.homeId;
 
      await axios
        .post(
          `${process.env.HOST}/admin/conversations/${this.contactId}/replies`,
          data,
          {
            headers: {
              Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
            }
          }
        )
        .then(() => {
          this.$emit("message-send-success", newReply);
        })
        .catch(e => {
          alert('ไม่สามารถบันทึกข้อความได้ กรุณาติดต่อเจ้าหน้าที่');
          throw e;
          this.$emit("message-send-fail", e);
        });

      this.message = "";
      this.selectImages = [];
      this.selectPDF = {};

      return true;
    },
    async sendGreetingMessage() {
      if (
        this.message.trim().length === 0
        && this.selectImages.length === 0
      ) return false;

      const now = Date.now();

      let images = [];
      if (
        this.selectImages.length > 0 &&
        this.selectImages[0].key &&
        this.selectImages[0].key !== ""
      ) {
        images = this.selectImages.map((selectImage) => selectImage.key)
      }

      const data = {
        images,
        detail: this.message.trim().length > 1
          ? this.message.trim()
          : null,
        homeId: this.homeId,
        projectId: this.projectId
      };
      if (!this.homeId || !this.projectId) {
        console.log("home id and project id cannot be null");
        return;
      }

      axios
        .post(`${process.env.HOST}/admin/greeting/${this.contactId}`, data, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          }
        })
        .then(response => {
          data.topicId = response.data.topicId;
          this.$emit("message-send-success", data);
        })
        .catch(e => {
          throw e;
          this.$emit("message-send-fail", e);
        });

      this.message = "";
      this.selectImages = [];

      return true;
    },
    closeMessageTemplate() {
      this.topicReplyTemplatesShow = false;
    },
    appendMessage(message) {
      this.message += `${message}`;
    },
    onSelectImage() {
      this.$refs.imageInput.click();
    },
    onRemoveImage(imageKey) {
      const selectImage = this.selectImages.filter(
        (image) => image.key !== imageKey
      );

      this.selectImages = selectImage;
      this.$refs.imageInput.value = "";
    },
    imageChange(imageFiles) {
      const imageArray = Array.from(
        { length: imageFiles.length }
      )

      let selectImageArray = []
      imageArray.forEach((_, index) => {
        const imageFile = imageFiles[index]

        selectImageArray.push(imageFile)
      })

      if ((selectImageArray.length + this.selectImages.length) > 10) {
        alert('สามารถใส่รูปได้ไม่เกิน 10 รูป');
        return false;
      }

      if (selectImageArray.length > 0) {
        const isImageLarger = selectImageArray.some(
          (imageFile) => imageFile.size / 1024 / 1024 > UPLOAD.MAX_FILE_SIZE_MB
        )

        if (isImageLarger) {
          alert('รูปขนาดเกิน 1 MB ไม่สามารถอัพโหลดได้');

          return false;
        }

        selectImageArray.forEach((imageFile, index) => {
          const reader = new FileReader();
          let url = "";

          reader.onload = e => {
            url = e.target.result;
            return  axios
              .get(`${process.env.HOST}/api/uploads/image`, {
                params: {
                  imageType: imageFile.type,
                  fileName: `topicimage${Date.now()}${index}`,
                  featureName: "topic"
                }
              })
              .then(res => {
                this.selectImages.push({
                  url,
                  name: imageFile.name,
                  file: imageFile,
                  key: res.data.imageKey
                })

                return axios.put(res.data.url, imageFile, {
                  headers: { "content-type": imageFile.type }
                });
              });
          };

          reader.readAsDataURL(imageFile);
        })
      }

      return true;
    },
    onSelectPDF() {
      this.$refs.pdfInput.click();
    },
    onRemovePDF() {
      this.selectPDF= {};
      this.$refs.pdfInput.value = "";
    },
    pdfFileChange(pdfFile) {
      if (pdfFile[0].size / 1024 / 1024 > UPLOAD.MAX_FILE_SIZE_MB) {
        alert('PDF ขนาดเกิน 1 MB ไม่สามารถอัพโหลดได้');
        return false;
      }

      const reader = new FileReader();
      const vm = this;
      let url = "";

      reader.onload = e => {
        url = e.target.result;
        return axios
          .get(`${process.env.HOST}/api/uploads/file`, {
            params: {
              contentType: pdfFile[0].type,
              fileName: `topic-pdf`,
              feature: "topic"
            }
          })
          .then(res => {
            vm.selectPDF = {
              url,
              name: pdfFile[0].name,
              file: pdfFile[0],
              key: res.data.fileKey
            };
            return axios.put(res.data.url, pdfFile[0], {
              headers: { "content-type": pdfFile[0].type }
            });
          });
      };
      reader.readAsDataURL(pdfFile[0]);

      return true;
    }
  }
};
</script>
<style lang="scss" scoped>
.message {
  &-box {
    background-color: $white;
    border-top: solid 1px #f5f5f5;

    &-disable {
      border-top: solid 1px #f5f5f5;
      background-color: rgba(33, 33, 33, 1);
      color: $white;
      z-index: 100;
      font-size: 18px;
      font-weight: bold;
      text-align: center;
      padding: 20px;
    }
  }
  &-icon {
    padding: 4px 8px;
    cursor: pointer;
  }
  &-title {
    .message-title-header {
      margin-top: 8px;
      height: 22px;
      h5 {
        font-size: 14px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.21;
        letter-spacing: -0.1px;
        margin: 0;
        margin-left: 10px;
        color: black;
      }

      .close-button {
        padding: 0;
        border: 0;
      }
    }
  }
  &-template {
    .template {
      &-header {
        height: 40px;
        border-bottom: 1px solid #f5f5f5;

        h5 {
          font-size: 14px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.21;
          letter-spacing: -0.1px;
          margin: 0;
          margin-left: 10px;
        }

        .close-button {
          padding: 0;
          border: 0;
        }
      }

      &-body {
        max-height: 160px;
        overflow: scroll;
        border-bottom: 1px solid #f5f5f5;

        ul.list {
          width: 100%;
          list-style: none;
          margin: 0;
          padding: 0;

          li {
            font-size: 14px;
            font-weight: 500;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.71;
            letter-spacing: normal;
            color: #4a4a4a;
            padding: 5px 16px;

            &:hover {
              background-color: #f4f4f2;
              color: $black;
            }
          }
        }
      }
    }
  }
  &-textarea {
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.63;
    letter-spacing: normal;
    color: #4a4a4a;

    width: 100%;
    height: 118px;
    padding: 10px 15px;
    margin: 0;
    border: none;
    resize: none;

    &:focus {
      outline: none;
    }
  }
}
.pdf-box {
  height: 60px;
  border-bottom: 1px solid #f5f5f5;
}
.topic-pdf {
  width: 170px;
  height: 23px;
  border-radius: 15px;
  background-color: #e0e0e0;
  float: left;
  position: relative;
  margin: 16px 10px 10px 10px;
}
.pdf-text {
  width: 135px;
  margin-left: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
}
.image-box {
  height: 350px;
  border-bottom: 1px solid #f5f5f5;
}

.image-remove {
  top: 5px;
  right: 5px;
  z-index: 89;
  opacity: 0.8;
  transition: opacity 0.25s ease;

  &:hover {
    opacity: 1;
  }
}
.topic-image {
  width: 90px;
  height: 90px;
  border-radius: 15px;
  background-color: #e0e0e0;
  float: left;
  position: sticky;
  margin: 16px 10px 10px 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/contact/ReplyBox.vue